import throttle from 'lodash/throttle'

export default {
  data () {
    return {
      videos: null,
      supportsPassive: false,
      windowHeight: window.innerHeight || document.documentElement.clientHeight,
      eventHandler: null
    }
  },
  mounted () {
    this.setSupportsPassive()
    this.videos = document.querySelectorAll('video:not(.no-scrollplay)')
    this.eventHandler = throttle(this.handleScroll, 200)
    window.addEventListener('scroll', this.eventHandler, this.supportsPassive ? { passive: true } : false)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.eventHandler)
  },
  methods: {
    setSupportsPassive () {
      try {
        var opts = Object.defineProperty({}, 'passive', {
          get () {
            this.supportsPassive = true
          }
        })
        window.addEventListener('test', null, opts)
      } catch (e) {}
    },
    handleScroll () {
      if (!this.videos) return // wrap around eventlistener

      this.setWindowHeight()
      const viewFactor = 1

      for (var i = 0; i < this.videos.length; i++) {
        this.playIfInView(this.videos[i], viewFactor)
      }
    },
    playIfInView (video, viewFactor) {
      const boundingClientRect = video.getBoundingClientRect()

      if (boundingClientRect.top >= -boundingClientRect.height * viewFactor &&
          boundingClientRect.bottom <= this.windowHeight + boundingClientRect.height * viewFactor) {
        video.play()
      } else {
        video.pause()
      }
    },
    setWindowHeight () {
      this.windowHeight = window.innerHeight || document.documentElement.clientHeight
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/automaticallyPlayVideo.js